export default __webpack_public_path__ + "static/media/2.0d60c3c1.jpg";